t = require('views/internal/teacup-with-helpers')('member_login')

module.exports = ->
  t.p '.member-login-email.u-bottom', ->
    t.text t.mustacheVar('email')

  t.mustacheBlock 'primary', ->
    t.p '.u-bottom.quiet', ->
      t.format 'primary-email'
  t.mustacheBlockInverted 'primary', ->
    t.a '.js-primary.u-bottom.quiet', { href: '#' }, ->
      t.format 'set-as-primary-email'

  t.p '.member-login-date-added.u-bottom.quiet', ->
    t.format 'added', { dateAdded: t.mustacheVar('dateAdded') }

  t.mustacheBlockInverted 'primary', ->
    t.icon 'close', { class: 'member-login-remove dark-hover js-remove' }



// WEBPACK FOOTER //
// ./app/scripts/views/templates/member_login.coffee